import { render, staticRenderFns } from "./courseMarket.vue?vue&type=template&id=ba12bae4&"
import script from "./courseMarket.vue?vue&type=script&lang=js&"
export * from "./courseMarket.vue?vue&type=script&lang=js&"
import style0 from "./courseMarket.vue?vue&type=style&index=0&id=ba12bae4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports